import { defineComponent as _defineComponent } from 'vue'
import { onClickOutside, useElementBounding, useWindowSize } from '@vueuse/core';
  import { computed, ref, toRefs, watch } from 'vue';
  import BaseCardMenuFloatWrapper from './BaseCardMenuFloatWrapper.vue';

  //eslint-disable-next-line
  
export default /*#__PURE__*/_defineComponent({
  __name: 'AppMenuFloat',
  props: {
    showMenu: {
      type: Boolean,
      required: true
    },
    top: {
      type: String,
      required: true
    },
    bottom: {
      type: String,
      required: true
    },
    positionX: {
      type: String,
      required: true
    },
    width: {
      type: String,
      default: 'w-[250px]'
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  emits: ['isVisibleMenuFloat'],
  setup(__props, { expose: __expose, emit: emits }) {
  __expose();

const props = __props;

  

  //eslint-disable-next-line
  

  const { top, bottom, width, positionX, showMenu, disabled } = toRefs(props);

  const blockMenu = ref(null);
  const buttonMenu = ref(null);
  const buttonMenuBounding = useElementBounding(buttonMenu);
  const blockMenuBounding = useElementBounding(blockMenu);
  const window = useWindowSize();

  onClickOutside(blockMenu, () => toggleMenuVisibility(), { ignore: [buttonMenu] });

  const position = computed(() => {
    return buttonMenuBounding.bottom.value + (blockMenuBounding.height.value + 10) < window.height.value ? top.value : bottom.value;
  });

  const toggleMenuVisibility = () => {
    if (!disabled.value) emits('isVisibleMenuFloat', !showMenu.value);
  };

  const customShowMenu = ref(showMenu.value);

  watch(showMenu, () => {
    if (showMenu.value) customShowMenu.value = true;
    else {
      setTimeout(() => {
        customShowMenu.value = false;
      }, 100);
    }
  });

const __returned__ = { emits, props, top, bottom, width, positionX, showMenu, disabled, blockMenu, buttonMenu, buttonMenuBounding, blockMenuBounding, window, position, toggleMenuVisibility, customShowMenu, get onClickOutside() { return onClickOutside }, get useElementBounding() { return useElementBounding }, get useWindowSize() { return useWindowSize }, computed, ref, toRefs, watch, BaseCardMenuFloatWrapper }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})